import MenuBookIcon from "@mui/icons-material/MenuBook";
import { Box, Button, Typography } from "@mui/material";
import { GridCardContent } from "components/atoms";
import { useState } from "react";
import { I18nTranslator, translations } from "utils/i18n";
import { Permission, UserGuide } from "./components";

const MENU: IItem[] = [
  {
    id: "General",
    title: translations.settings.general,
    subItems: [
      {
        id: "Permission",
        title: translations.settings.permissionList,
        component: <Permission />,
      },
    ],
  },
  {
    id: "Other",
    title: translations.settings.order,
    subItems: [
      {
        id: "UserGuide",
        title: translations.settings.userguide,
        component: <UserGuide />,
      },
      // {
      //   id: "About",
      //   title: "Giới thiệu",
      // },
    ],
  },
];
interface ISubItem {
  id: string;
  title: string;
  component?: JSX.Element;
}
interface IItem extends ISubItem {
  subItems: ISubItem[];
}

const Setting = () => {
  const [itemSelected, setItemSelected] = useState<string>(
    MENU[0].subItems[0].id
  );


  return (
    <GridCardContent
      sx={{ p: 2, flexDirection: "column", alignItems: "flex-start" }}
    >
      <Typography variant="h1" sx={{ paddingLeft: "10px" }}>
        {I18nTranslator(translations.setting)}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          marginTop: "20px",
          width: "100%",
        }}
      >
        <Box
          sx={{
            flex: 1,
            minWidth: "300px",
            borderRight: 0.5,
            paddingRight: "20px",
          }}
        >
          <SettingItemTitle
            itemSelected={itemSelected}
            setItemSelected={setItemSelected}
          />
        </Box>
        <Box sx={{ flex: 5, width: "100%", paddingLeft: "20px" }}>
          {
            MENU.reduce((a, b) => [...a, ...b.subItems], [] as ISubItem[]).find(
              (e) => e.id === itemSelected
            )?.component
          }
        </Box>
      </Box>
    </GridCardContent>
  );
};

const SettingItemTitle = (props: {
  itemSelected: any;
  setItemSelected(id: string): void;
}) => {
  const { itemSelected, setItemSelected } = props;
  return (
    <>
      {MENU.map((item) => {
        return (
          <Box sx={{ marginBottom: "10px" }}>
            <Typography
              variant="h5"
              color={"gray"}
              sx={{ paddingLeft: "10px", marginBottom: "6px" }}
            >
              {I18nTranslator(item.title)}
            </Typography>
            {item.subItems.map((subItem: ISubItem) => {
              const isSelected = subItem.id === itemSelected;
              return (
                <Button
                  startIcon={<MenuBookIcon />}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    color: isSelected ? "primary" : "black",
                    fontWeight: 500,
                    backgroundColor: isSelected ? "#cfe5fa" : "white",
                    marginTop: "6px",
                  }}
                  onClick={() => setItemSelected(subItem.id)}
                >
                  {I18nTranslator(subItem.title)}
                </Button>
              );
            })}
          </Box>
        );
      })}
    </>
  );
};

export default Setting;
